<template>
  <div id="dynamicIframe" v-if="pages">
    <!--<el-card class="box-card w-100" id="staticBox">-->
    <div>
      <el-row :gutter="20">
        <!--<el-col :span="12"></el-col>-->
        <div class="p-r-20 tr">
          <i
            class="fa m-r-5 cur_pointer c-g6"
            :title="i.title"
            :class="i.iconClass"
            @click="switchIframe(i)"
            v-for="(i, index) in pages"
            :key="index"
          ></i>
          <el-button style="padding: 3px 0" type="text" @click="clearUrl" v-show="iframeUrl"
            ><i :class="[iframeUrl ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i
          ></el-button>
        </div>
      </el-row>
    </div>
    <iframe
      id="switchIframe"
      style="width: 100%;height: 700px"
      :src="iframeUrl"
      v-show="iframeUrl"
    ></iframe>
    <!--</el-card>-->
  </div>
</template>
<script type="text/babel">
export default {
  name: 'dynamicIframe',
  components: {},
  props: ['tagId', 'tagCode', 'pages', 'data'],
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  data() {
    return {
      iframeUrl: '',
    }
  },
  methods: {
    clearUrl() {
      this.iframeUrl = ''
    },
    async switchIframe(obj) {
      if (this.iframeUrl === obj.url) {
        this.iframeUrl = ''
      } else {
        this.iframeUrl = obj.url
        console.log(
          'postmessage',
          _.assign(
            {
              currentProject: this.currentProject,
              userInfo: this.userInfo,
              action: obj.action,
            },
            this.data
          )
        )
        setTimeout(() => {
          document.getElementById('switchIframe').contentWindow.postMessage(
            _.assign(
              {
                currentProject: this.currentProject,
                userInfo: this.userInfo,
                action: obj.action,
              },
              this.data
            ),
            '*'
          )
        }, 1000)
      }
    },
  },
  created() {
    this.iframeUrl = ''
  },
}
</script>
